<template>
  <div class="config_main_manage_background config-selection-page">
    <!-- 上部导航栏样式 -->
    <div class="main_topnav config_main_manage_topnav">
      <top-nav class="main_topnav">
        <top-nav-item class="left_item"
                      @click.native="configGoPreviousPageHandle">
          <img class="main_top_img"
               slot="topnavimg"
               src="~assets/img/topnav/zuofanhui.png"
               alt />
          <div slot="topimgtext">返回</div>
        </top-nav-item>
        <top-nav-item>
          <div slot="topimgtext">选择一个区域</div>
        </top-nav-item>
        <top-nav-item class="right_item"
                      @click.native="configReturnContronBtnHandle">
          <img class="main_top_img"
               slot="topnavimg"
               src="~assets/img/topnav/shebei_home.png"
               alt />
        </top-nav-item>
      </top-nav>
    </div>

    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
        <config-hang @click.native="configAddSceneBtnHandle">
          <span slot="config_hang_ele2">添加一个新区域</span>
          <img slot="config_hang_ele4"
               src="~assets/img/config/youjiantou.png"
               alt />
        </config-hang>
        <config-title-hang>
          <span slot="config_title_hang_ele2">全部的区域</span>
          <input slot="config_title_hang_ele8"
                 type="text"
                 placeholder="快速搜索"
                 v-model="scerchValue" />
        </config-title-hang>

        <!-- 服务器返回的所有区域列表 -->
        <config-hang v-for="(value, index) in serveRegionListData.allRegion"
                     :key="index"
                     @click.native="selectRegionBtnHandle(value)"
                     :selectState="OneInfo.regionId === value.regionId">
          <span slot="config_hang_ele2">{{ value.regionName }}</span>
          <img slot="config_hang_weixuan"
               src="~assets/img/config/weixuan.png"
               alt />
          <img slot="config_hang_xuanzhong"
               src="~assets/img/config/xuanzhong.png"
               alt />
        </config-hang>


      </div>
    </div>
    <footer class="config-selection-actions">
      <button type="button" class="public_config_que_ren_btn" @click="saveReturnBtnHandle">保存并返回</button>
    </footer>
  </div>
</template>

<script>
import topNav from "components/common/topnav/topnav";
import topNavItem from "components/common/topnav/topnavitem";
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
import { mediumslateblue } from "color-name";

export default {
  data () {
    return {
      serveRegionListData: {
        ///服务器返回的所有区域信息的数据
        allRegion: [], ///所有的区域信息
        followRegion: [], ////收藏的区域信息
      },
      serveRegionListDataBack: {
        ///服务器返回的所有区域信息的数据
        allRegion: [], ///所有的区域信息
        followRegion: [], ////收藏的区域信息
      },
      scerchValue: "", // 搜索使用
      // 代号 20231207-1  组功能实现
      OneInfo: {
        /// ///区域信息和区域ID 在创建页面时由 公共仓库获得
        regionId: "",
        regionName: "",
      },
    };
  },
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang,
  },
  methods: {
    configGoPreviousPageHandle () {
      ////返回上一级的按钮  返回上一级  不保存当前勾选项
      this.$router.go(-1);
    },
    selectRegionBtnHandle (value) {
      console.log("111111");
      console.log(value);

      /// 点击了区域按钮 显示勾选img  这样操作其实是直接操作的仓库，因为现在OneInfo它已经指向了仓库地址
      ///这样做其实是不好的，因为没有通过VUEX的提交功能区修改，这样后期调试是没办法通过工具检测数据修改来源的。
      this.OneInfo.regionName = value.regionName;
      this.OneInfo.regionId = value.regionId;
    },
    saveReturnBtnHandle () {
      ///保存并返回按钮点击了
      if (this.OneInfo.regionId === "") {
        this.$toast("请至少选择一个区域！");
        return;
      }
      ////提交页面用户设置的部分场景信息的区域信息地址 到仓库（注意提交的是地址，但实际不是地址，最后做了一下深层克隆）
      console.log(typeof this.$route.query.type);
      //补UBG 这里不用===是为了页面跳转之后 type进行了类型转换，所有用了==
      if (this.$route.query.type == 1) {
        ///1代表是场景页面进来 选择区域的  出去的时候需要判断提交的地址
        console.log(this.OneInfo);

        this.$store.dispatch("asyUpdataOneSceneinfo", this.OneInfo);
      } else if (this.$route.query.type == 2) {
        ///2代表是对象页面进来 选择区域的  进来的时候需要判断拉取的地址
        this.$store.dispatch(
          "asyUpdataServeOneObjectRegioninfo",
          this.OneInfo
        ); ///异步提交对象区域信息，不是地址
      } else if (this.$route.query.type == 3) {
        // 代号 20231207-1  组功能实现
        ///3代表是组页面进来 选择区域的  出去的时候需要判断提交的地址
        console.log(this.OneInfo);

        this.$store.dispatch("asyUpdataOneGroupinfo", this.OneInfo);
      }

      this.$router.go(-1);
    },
    configReturnContronBtnHandle () {
      ////配置页面的主页返回按钮被点击了
      this.$router.replace(this.$store.state.publicinfo.configReturnPath);
    },
    configAddSceneBtnHandle () {
      ////添加一个新区域按钮按下了
      this.$router.push({ path: "/RegionManage", query: { type: "config" } });
    },
    //业内数据搜索显示  //搜索使用
    seraceDataShow (charData) {
      if (
        this.serveRegionListData.allRegion &&
        this.serveRegionListDataBack.allRegion
      ) {
        //数据是合法存在的
        this.serveRegionListData.allRegion = this.serveRegionListData.allRegion.concat(
          this.serveRegionListDataBack.allRegion
        );
        this.serveRegionListDataBack.allRegion.length = 0;
        if (charData.match(/^[ ]*$/)) {
          //说明为空 或多个空
        } else {
          let dataLength = this.serveRegionListData.allRegion.length;
          for (let i = 0; i < dataLength; i++) {
            if (
              this.serveRegionListData.allRegion[i].regionName.indexOf(charData) == -1
            ) {
              // && this.serveRegionListData.allRegion[i].checked == false
              // 说明没有这个字符
              this.serveRegionListDataBack.allRegion.push(
                this.serveRegionListData.allRegion[i]
              );
              this.serveRegionListData.allRegion.splice(i, 1);
              dataLength--;
              i--;
            }
          }
        }
        console.log(this.serveRegionListData.allRegion);
      }
    }
  },
  watch: {
    scerchValue: function (val) {
      console.log("发生变化" + val);
      this.seraceDataShow(val); //新增页内搜索
    },
  },
  created () {
    console.log("created阶段");

    /// 请求区域信息接口，获取数据
    this.$request({
      method: "post",
      url: "/region/findRegion",
      data: {
        token: this.$store.state.token,
      },
    })
      .then((res) => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message);
          ////说明信息填写错误,控制失败了，
          return;
        } else {
          ////、控制成功了
          this.serveRegionListData = res.data.data; ////拿到服务器返回的数据结果
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // this.OneSceneinfo = this.$store.state.configinfo.OneSceneinfo;
    //需要把进来时的仓库的状态更新进来，根据页面进来的类型进行判断
    if (this.$route.query.type === 1) {
      ///1代表是场景页面进来 选择区域的  进来的时候需要判断拉取数据
      this.OneInfo.regionName = this.$store.state.configinfo.OneSceneinfo.regionName;
      this.OneInfo.regionId = this.$store.state.configinfo.OneSceneinfo.regionId;
    } else if (this.$route.query.type === 2) {
      ///2代表是对象页面进来 选择区域的  进来的时候需要判断拉取数据
      this.OneInfo.regionName = this.$store.state.configinfo.ServeOneObjectinfo.regionName;
      this.OneInfo.regionId = this.$store.state.configinfo.ServeOneObjectinfo.regionId;
    } else if (this.$route.query.type === 3) {
      // 代号 20231207-1  组功能实现
      ///3代表是组页面进来 选择区域的  进来的时候需要判断拉取数据
      this.OneInfo.regionName = this.$store.state.configinfo.OneGroupinfo.regionName;
      this.OneInfo.regionId = this.$store.state.configinfo.OneGroupinfo.regionId;
    }
  },
};
</script>

<style></style>
